import * as React from "react";
import "./FacesheetScore.scss";
import { formatScore } from "../../services/scoreFormatter";

export const FacesheetScore = ({ scores, criticalFactors, isIncomplete }) => {
    const overallScore = isIncomplete === true ? "" : formatScore(scores.overallScore);
    const fitScore = isIncomplete === true ? "" : formatScore(scores.fitScore);
    const riskScore = isIncomplete === true ? "" : formatScore(scores.riskScore);
    const reliabilityScore = isIncomplete === true ? "" : formatScore(scores.reliabilityScore);

    return (
        <div className="facesheet-personal facesheet-score">
            {overallScore && (
                <>
                    <div className="overall-score">
                        <span className="p-regular">
                            <span className="h4">Overall : </span>
                            {overallScore}
                        </span>
                    </div>
                    <div className="sub-scores">
                        <span className="p-regular">
                            <span className="h5">Fit : </span>
                            {fitScore}
                        </span>
                        <span className="p-regular">
                            <span className="h5">Risk : </span>
                            {riskScore}
                        </span>
                        <span className="p-regular">
                            <span className="h5">Reliability : </span>
                            {reliabilityScore}
                        </span>
                    </div>
                </>
            )}
            {!overallScore && (
                <>
                    <div className="overall-score">
                        <span className="p-regular">
                            <span className="h4">Overall : - </span>
                        </span>
                    </div>
                </>
            )}
            <div className="score-reasons">
                <h4>Critical Factors</h4>
                <ul>
                    {criticalFactors.riskScoreReasons
                        .filter(x => x.weight < 0)
                        .map((x, i) => {
                            return (
                                <>
                                    <li key={`reason_${i}`}>
                                        <p>{x.reason}</p>
                                    </li>
                                </>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
};
